import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'gap-vertical',
  size: 24,
  node: [
    ['path', { d: 'M2 12h2', key: '1t8f8n' }],
    ['path', { d: 'M8 12h2', key: 'f27al2' }],
    ['path', { d: 'M14 12h2', key: '5yx4ln' }],
    ['path', { d: 'M20 12h2', key: '1q8mjw' }],
    ['path', { d: 'M3 21v-3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3', key: 'mbp45m' }],
    ['path', { d: 'M3 3v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3', key: 'kci8nr' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name GapVertical
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxMmgyIiAvPgogIDxwYXRoIGQ9Ik04IDEyaDIiIC8+CiAgPHBhdGggZD0iTTE0IDEyaDIiIC8+CiAgPHBhdGggZD0iTTIwIDEyaDIiIC8+CiAgPHBhdGggZD0iTTMgMjF2LTNhMiAyIDAgMCAxIDItMmgxNGEyIDIgMCAwIDEgMiAydjMiIC8+CiAgPHBhdGggZD0iTTMgM3YzYTIgMiAwIDAgMCAyIDJoMTRhMiAyIDAgMCAwIDItMlYzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/gap-vertical
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GapVertical = createLucideIcon(__iconData);

export default GapVertical;
